export const emptyFight = {
	id: 0,
	jurors: {},
	participants: {},
	teams: {},
	stages: [],
	name: "",
	fightnr: 0,
};

export enum Phase {
	fightToStart = 0,
	presentationReporter = 1,
	questionsOfOpponent = 2,
	prepForOpponent = 3,
	statementOfOpponent = 4,
	discussion = 5,
	summaryOfDiscussion = 6,
	questionsOfReviewer = 7,
	prepForReviewer = 8,
	review = 9,
	concludingRemarksReporter = 10,
	questionsOfJury = 11,
	grading = 12,
}

export const phasesForTimer = [
	{ duration: 0, name: "Preparation for Fight" },
	{ duration: 12 * 60, name: "Presentation" },
	{ duration: 2 * 60, name: "Clarifying Questions Opponent" },
	{ duration: 3 * 60, name: "Preparation of the Opponent" },
	{ duration: 5 * 60, name: "Statement of Opponenet" },
	{ duration: 6 * 60, name: "Discussion" },
	{ duration: 1 * 60, name: "Summary of Discussion" },
	{ duration: 3 * 60, name: "Questions of the Reviewer" },
	{ duration: 2 * 60, name: "Preparation of the Reviewer" },
	{ duration: 4 * 60, name: "Review" },
	{ duration: 2 * 60, name: "Concluding remarks of the Reporter" },
	{ duration: 5 * 60, name: "Questions of the Jury" },
	{ duration: 5 * 60, name: "Grading" },
];

export const partsFight3Stages = [
	{ type: "setup", name: "Setup" },
	{ type: "stage", stagenumber: 1, name: "Stage 1" },
	{ type: "break", name: "Break" },
	{ type: "stage", stagenumber: 2, name: "Stage 2" },
	{ type: "break", name: "Break" },
	{ type: "stage", stagenumber: 3, name: "Stage 3" },
	{ type: "finished", name: "End" },
];
export const partsFight4Stages = [
	{ type: "setup", name: "Setup" },
	{ type: "stage", stagenumber: 1, name: "Stage 1" },
	{ type: "break", name: "Break" },
	{ type: "stage", stagenumber: 2, name: "Stage 2" },
	{ type: "break", name: "Break" },
	{ type: "stage", stagenumber: 3, name: "Stage 3" },
	{ type: "break", name: "Break" },
	{ type: "stage", stagenumber: 4, name: "Stage 4" },
	{ type: "finished", name: "End" },
];



// WEBPACK FOOTER //
// ./src/constants.tsx